import React from "react";
import { Button, Container, Row, Col } from 'react-bootstrap';
import { Nav } from 'react-bootstrap';
import * as path from 'svg-path-properties';
import * as d3 from 'd3';
import * as d3s from 'd3-shape';
import { v4 as uuidv4 } from 'uuid';
import locale from "../locale";

export default class LineGraph extends React.Component {
    /** Set to true for debug mode. */
    debug = false;
    state = {  }
    gridRef = React.createRef();
    linesRef = React.createRef();
    bottomMargin = 40;
    leftMargin = 40;
    topMargin = 10;
    marker = null;
    bounds = {
        x: [null, null],
        y: [null, null]
    };
    uniqueId = uuidv4();

    constructor(props) {
        super();
        this.height = (props.height - this.bottomMargin - this.topMargin) || 300;
        this.width = (props.width - this.leftMargin) || 600;
    }

    calcBounds() {
        this.bounds = {
            x: [ null, null ],
            y: [ null, null ]
        };
        this.props.series.forEach((serie) => {
            let xName = serie.xName || "time";
            let yName = serie.yName || "ActualLoad";
            this.props.data.forEach((item) => {
                if (item[yName] === null || typeof item[yName] === "undefined")
                    return;
                if (item[xName] === null || typeof item[xName] === "undefined")
                    return;
                if (typeof item[xName] !== "object")
                    item[xName] = new Date(item[xName]);
                if (typeof item[yName] !== "number")
                    item[yName] = Number(item[yName]);
                if (isNaN(item[yName]))
                    return;
                this.bounds.x[0] = this.bounds.x[0] === null ? item[xName].getTime() : Math.min(item[xName].getTime(), this.bounds.x[0]);
                this.bounds.x[1] = this.bounds.x[1] === null ? item[xName].getTime() : Math.max(item[xName].getTime(), this.bounds.x[1]);
                this.bounds.y[0] = this.bounds.y[0] === null ? item[yName] : Math.min(item[yName], this.bounds.y[0]);
                this.bounds.y[1] = this.bounds.y[1] === null ? item[yName] : Math.max(item[yName], this.bounds.y[1]);
            });
        });
        if (this.bounds.y[0])
            this.bounds.y[0] *= 0.97;
        if (this.bounds.y[1])
            this.bounds.y[1] *= 1.03;

        if (this.props.defaultBounds?.x) {
            this.bounds.x = this.props.defaultBounds?.x;
        }
        if (this.props.defaultBounds?.y) {
            this.bounds.y = this.props.defaultBounds?.y;
        }

        /*if (this.props.title === "PH") {
            console.log(this.props.data.length, this.bounds);
        }*/
        /*
        serie.bounds = {
            x: [
                typeof serie.xMin !== "undefined" ? serie.xMin : null, 
                typeof serie.xMax !== "undefined" ? serie.xMax : null, 
            ],
            y: [
                typeof serie.yMin !== "undefined" ? serie.yMin : null, 
                typeof serie.yMax !== "undefined" ? serie.yMax : null
            ]
        };
        */

        this.scaleX = d3.scaleTime()
                        .domain(this.bounds.x || [ new Date().getTime() - 60*60*24*1000 , new Date()])
                        .range([0, this.width]);
        this.scaleY = d3.scaleLinear()
                        .domain(this.bounds.y || [0, 100])
                        .range([this.height, 0]);
    }

    splitSeries(data, xName, gapThreshold) {
        let subSeries = [];
        let curr = [];
        let lastPoint = null;
        for (let point of data) {
            if (lastPoint
                // Specified absolute distance
                && (lastPoint[ xName ] < point[ xName ] - gapThreshold)
                // Only split if the gap would produce a visible amount of pixel width
                && (
                    this.scaleX(point[ xName ]) - this.scaleX(lastPoint[ xName ])
                ) > 4
            ) {
                // Line has just broken here.
                subSeries.push(curr);
                curr = [];
            }
            curr.push(point);
            lastPoint = point;
        }
        subSeries.push(curr);

        return subSeries;
    }

    renderSerie(serie) {
        let xName = serie.xName || "time";
        let yName = serie.yName || "ActualLoad";
        this.height = (this.props.height - this.bottomMargin - this.topMargin) || 300;
        this.width = (this.props.width - this.leftMargin) || 600;
        this.origin = [this.leftMargin, this.height];
        if (!this.props.data)
            return <div key="placeholder">Loading...</div>;

        let data = this.props.data
                        .filter(row => row[yName] && row[yName] !== null)
                        .filter(row => !isNaN(Number(row[yName])) );
        if (data.length === 0) {
            //console.log("No data for serie ", serie);
            return null;
        }
        //console.log("Serie data", yName, data);

        const subSeries = this.splitSeries(data, xName, serie.gapThreshold);
        const lines = [];

        subSeries.forEach((data, idxData) => {
            if (data.length > 1) {
                let line = d3s.line()
                            .x(d => this.scaleX(new Date(d[xName]).getTime()) )
                            .y(d => this.scaleY(d[yName]))
                            .curve(d3s.curveLinear)(data);
                //let pathProps = path.svgPathProperties(line);
                
                
                lines.push(
                    <path d={ line } fill="transparent" stroke={serie.color} strokeWidth={ serie.lineWidth || 1 } key={'serie_stroke_' + idxData + "_" + yName } clipPath={ "url(#graphDataArea" + this.uniqueId + ")" } />
                );
                if (serie.fill) {
                    lines.push(
                        <path d={`${line} L ${this.scaleX(this.bounds.x[1])} ${this.origin[1]} L ${this.origin[0]} ${this.origin[1]}`} fill={serie.fill} key={'serie_fill_' + idxData + "_" + yName} clipPath={ "url(#graphDataArea" + this.uniqueId + ")" } />
                    );
                }
            } else {
                const d = data[ 0 ];
                lines.push(
                    <circle
                        cx={ this.scaleX(new Date(d[xName]).getTime()) }
                        cy={ this.scaleY(d[yName]) }
                        r={ 2 }
                        fill={ serie.color }
                        key={'serie_fill_' + idxData + "_" + yName} clipPath={ "url(#graphDataArea" + this.uniqueId + ")" }
                    />
                );
            }
        });

        if (this.debug) {
            data.forEach((item, idx) => {
                lines.push(
                    <line
                        key={ "debugLines_" + yName + "_1_" + idx }
                        x1={ this.scaleX(new Date(item[xName]).getTime()) - 5 }
                        y1={ this.scaleY(item[yName]) - 5}
                        x2={ this.scaleX(new Date(item[xName]).getTime()) + 5 }
                        y2={ this.scaleY(item[yName]) + 5}
                        stroke={ serie.color }
                        width={ 2 }
                    />
                );
                lines.push(
                    <line
                        key={ "debugLines_" + yName + "_2_" + idx }
                        x1={ this.scaleX(new Date(item[xName]).getTime()) +5  }
                        y1={ this.scaleY(item[yName]) - 5 }
                        x2={ this.scaleX(new Date(item[xName]).getTime()) -5 }
                        y2={ this.scaleY(item[yName]) + 5 }
                        stroke={ serie.color }
                        width={ 2 }
                    />
                );
            });
        }   

        return lines;
    }

    renderMarker() {
        let marker = [];
        
        if (!this.marker) {
            return;
        }

        if (this.marker !== null) {
            let correctedX = this.marker[0];

            marker.push(( 
                <g key="marker" transform={"translate(" + correctedX + ", 0)"} >
                    <path d={'M 0 0 L 0 ' + this.height} stroke="rgba(0,0,0,0.5)" strokeWidth={1} />
                </g>
            ));
            let serie = this.props.series[0];
            let xName = serie.xName || "time";
            let yName = serie.yName || "ActualLoad";
            let pointXValue = this.scaleX.invert(correctedX);
            let pointYValue = null;
            let pointYX = null;
            for (let point of this.props.data) {
                if (
                    pointYValue === null || 
                    Math.abs(new Date(point[xName]).getTime() - pointXValue.getTime()) < Math.abs(pointYX.getTime() - pointXValue.getTime())
                ) {
                    pointYValue = point[yName];
                    pointYX = new Date(point[xName]);
                }
            }
            /*marker.push(( 
                <text transform={"translate(" + (this.width - 150 ) + ", " + (this.height + this.bottomMargin - 5) + ")"} key="markerValue">{
                    d3.timeFormat("%m-%d %H:%M")(pointYX) + " - " + pointYValue
                }</text>
            ));*/
            //console.log(pointXValue, pointYValue);
        }

        return marker;
    }

    getMarkerValue(serie) {
        let pointYValue = null;

        if (this.marker !== null) {
            let correctedX = this.marker[0];
            //let serie = this.props.series[0];
            let xName = serie.xName || "time";
            let yName = serie.yName || "ActualLoad";
            let pointXValue = this.scaleX.invert(correctedX);
            let pointYX = null;
            for (let point of this.props.data) {
                if (
                    pointYValue === null || 
                    (point[xName] && point[yName] &&
                    Math.abs(new Date(point[xName]).getTime() - pointXValue.getTime()) < Math.abs(pointYX.getTime() - pointXValue.getTime()))
                ) {
                    pointYValue = point[yName];
                    pointYX = new Date(point[xName]);
                }
            }
        }

        return pointYValue;
    }

    renderAxes() {
        if (!this.props.data || this.props.data?.length === 0) {
            return null;
        }
        const svgElement = d3.select(this.gridRef.current);
        this.gridRef.current.innerHTML = "";
            

        const axisGeneratorX = d3.axisBottom(this.scaleX)
                                    .ticks(8);
        if (this.props.xScale !== false) {
            if (this.props.xLabels === false) {
                timeFormat = "";
            }
            svgElement.append("g")
                .attr("transform", "translate(0, " + this.height + ")")
                .attr("class", "scale scaleX")
                .call(axisGeneratorX
                        .tickFormat(val =>
                            (this.bounds.x[1] - this.bounds.x[0]) > 3600 * 1000 * 24
                                ? locale.formatDate(val, this.props.timeZone)
                                : locale.formatTime(val, false, false, this.props.timeZone)
                            )
                        )
            ;
        }
        if (this.props.xGrid !== false) {
            svgElement.append("g")
                .attr("transform", "translate(0, " + this.height + ")")
                .attr("class", "grid")
                .call(axisGeneratorX
                            .tickSize( -this.height )
                            .tickFormat("")
                );
        }

        const axisGeneratorY = d3.axisLeft(this.scaleY)
                                .ticks(10);

        if (this.props.yScale !== false) {
            svgElement.append("g")
                .attr("class", "scale scaleY")
                .call(axisGeneratorY);
        }

        if (this.props.yGrid !== false) {
            svgElement.append("g")
                .attr("class", "grid")
                .call(axisGeneratorY
                            .tickSize( -this.width )
                            .tickFormat("")
                );
        }
    }

    setMarker(x, y) {
        //console.log(x, y);
        this.marker = [x, y];
    };

    render() { 
        let lines = [];
        let xPos = 0;
        if (this.gridRef.current && this.linesRef.current) {
            let labelXJump = this.props.width / (this.props.series.length);
            this.calcBounds();
            this.renderAxes();
            if (this.props.data?.length > 0) {
                this.props.series.forEach((serie) => {
                    let val = this.getMarkerValue(serie);
                    lines = lines.concat(this.renderSerie(serie));
                    lines.push(( 
                        <text 
                            transform={"translate(" + xPos + ", " + (this.height + this.bottomMargin - 5) + ")"} 
                            fill={serie.color }
                            key={ "name_" + serie.yName }
                        >
                            { serie.title || serie.yName} { val ? val : "" }
                        </text>
                    ));
                    xPos += labelXJump;
                });
            }
            if (this.marker) {
                lines = lines.concat([this.renderMarker()]);
            }
        }

        return (
            <div>
                <div>{ this.props.title }</div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={ this.props.width }
                    height={ this.props.height }
                    viewBox={`0 0 ${this.props.width} ${this.props.height}`}
                    className="lineGraph"
                    style={{ width: this.props.width + 'px', height: this.props.height + 'px' }}
                    key={ "LineGraph" }
                    onClick={(e) => {
                        if (!this.props.enableMarker) return;
                        var rect = this.linesRef.current.getBoundingClientRect();
                        var x = e.clientX - rect.left; 
                        var y = e.clientY - rect.top;
                        this.setMarker(x,y);
                        this.setState({});
                    }}
                >
                    <defs>
                        <clipPath id={ "graphDataArea" + this.uniqueId } clipPathUnits="userSpaceOnUse">
                            <rect x={ 0 } y={ 0 } width={ this.props.width - this.leftMargin } height={ this.props.height }/>
                        </clipPath>
                    </defs>
                    <g transform={"translate(" + this.leftMargin + ", " + this.topMargin + ")"}  >
                        <g ref={ this.gridRef } ></g>
                        <g ref={ this.linesRef } >{ lines }</g>
                    </g>
                </svg>
            </div>
        );
    }
}